<template>
  <div class="page_title_intop">{{pageName}}</div>
</template>

<script>
export default {
    props:{
        pageName:{
            type: String,
            defalut: ''
        }
    }
}
</script>

<style lang="scss" scoped>
    .page_title_intop{
          height: 50px;
          line-height: 50px;
          padding-left: 24px;
          margin: 0 -40px;
          font-size: 18px;
          font-weight: 600;
          color: #000;
          background: #FFFFFF;
    }
</style>
